import React, { Component, Fragment, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';
import onClickOutside from 'react-onclickoutside';
import Logo from '../Logo';
import SiteNavLink from '../SiteNavLink';
import SvgIcon from '../SvgIcon';
import Dropdown from '../Dropdown';
import List from '../List';
import Link from '../Link';
import Loader from '../Loader';
import Columnizer from '../Columnizer';
import AutoSuggestionsEl from '../AutoSuggestionsEl';
import {readingProgram, appLanguages , otherAppLanguages , defaultAppLanguages,  siteHeaderHight, csf,  trendingLanguages, menuPageSelected, ece, flpHome, stemHome, staticPageImages, siteLocale} from '../../lib/constants'
import classNames from 'classnames';
import MenuDivider from '../MenuDivider';
import queryString from 'query-string';
import sortBy from 'lodash/sortBy';
import {
  links,
  subDomains,
  gaEventCategories,
  gaEventActions,
  gaEventLabel
 } from '../../lib/constants';
import Caret from '../Caret';
import './SiteHeader.scss';

const SiteNotification = lazy(() => import('../SiteNotification'));
const PTRTooltip = lazy(() => import('../PTRTooltip/PTRTooltip'));
const DdlSiteHeader = lazy(() => import('../DdlSiteHeader'));
const GdSiteHeader = lazy(() => import('../GdSiteHeader'));
const SearchModal = lazy(() => import('../SearchModal'));


const ExpandableMenu = ({content, backLinkContent, baseClassName, goBackTo, updateActiveMenuSelected, menuSelected, rightIcon, leftIcon, isRtl, t, onTriggerEvents, eventLabel, eventAction}) => {

      const classes = {
        [`${baseClassName}__nav-secondary-header`]: true,
        [`${baseClassName}__nav-secondary-header--light`]: menuSelected !== menuPageSelected.main
      }

      return (
        <div >
          {backLinkContent && <SiteNavLink variant="bordered" isRtl={isRtl} parentClassName={classNames(classes)} respondFontSize truncateLongText fullWidth noLeftPadding={isRtl}
            onClick={()=> {
              if (goBackTo) {
                updateActiveMenuSelected(goBackTo);
                if (onTriggerEvents) {
                  onTriggerEvents({
                    gaEvent: `clicked_${eventAction}`,
                    gaCategory: gaEventCategories.navigation,
                    gaLabel: `${gaEventLabel.mobileApp}_${eventLabel}`
                  })
                }
              }
            }} >
            {leftIcon}
            {backLinkContent}
            {rightIcon}
          </SiteNavLink> }
          {(menuSelected !== menuPageSelected.main && menuSelected !== menuPageSelected.user && menuSelected !== menuPageSelected.bottomResources && menuSelected !== menuPageSelected.gcr && menuSelected !== menuPageSelected.mobSiteLang && menuSelected !== menuPageSelected.bottomGcr) 
          && <div className={(isRtl && menuSelected !== menuPageSelected.siteLang) ? `${baseClassName}__sub-header ${baseClassName}__sub-header--rtl` : `${baseClassName}__sub-header`}>{t(`global.${menuSelected}`,1)}</div>}
          {content}
        </div>
      )
}

@translate()
@onClickOutside
class SiteHeader extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      isSearchModalOpen: false,
      dropdownSelectedLanguage: localStorage.getItem('locale') || 'en',
      truncateTitle : false,
      showBottomGcr: false
    }
  }

  componentWillMount() {
    window.addEventListener(
      "storage",
      event => {
        if ( event.key === "sw-log-in-out-activity" && /\/v0\//g.test(window.location.href)) {
          window.location.href = links.home();
        }
        else if(event.key === "sw-log-in-out-activity") {
          window.location.reload();
        }
        // Below condition for reloading all the tabs when you are change the localization language.
        if ( event.key === "locale" ) {
          let language =  localStorage.getItem('locale') || 'en';    
          let oldUrl = window.location.pathname + window.location.search + window.location.hash

          let reg1 = new RegExp('^/(?:(?:e[ns]|f[ar]|hi|kok)|[amou]r)$')
          let reg2 = new RegExp('^/(?:(?:e[ns]|f[ar]|hi|kok)|[amou]r)/')
          if(reg1.test(oldUrl)) {
            window.location.assign(oldUrl.replace(reg1, `/${language}`));
          }
          else if(reg2.test(oldUrl)){
            window.location.assign(oldUrl.replace(reg2, `/${language}/`));
          }
          else {
            window.location.assign(`/${language}/${oldUrl}`);
          }
        }
      },
      false
    );
  }


componentDidMount () {
    const el = document.getElementsByClassName('pb-site-header__primary-container')[0]
    if ( el.clientHeight > siteHeaderHight.height ) {
      this.setState({ truncateTitle : true })
    }
}


  componentDidUpdate( prevProps) {
    const { viewport } = this.props;
    window.onscroll = function() {myFunction()};  
    
   if( this.props !== prevProps) {
    const el = document.getElementsByClassName('pb-site-header__primary-container')[0]
    if ( el.clientHeight > siteHeaderHight.height ) {
      this.setState({ truncateTitle : true })
    }
  }
    function myFunction() {
      var primaryHeader = document.getElementsByClassName("pb-site-header__primary-container")[0];
      var header = document.getElementsByClassName("pb-site-header__nav-secondary")[0];
      
      if(viewport.large && header) {
        let sticky = header.offsetTop;
        if (window.pageYOffset > sticky) {
          if(primaryHeader) primaryHeader.classList.remove("pb-site-header__primary-container--sticky");
          header.classList.add("pb-site-header__nav-secondary--sticky");
        } else {
          header.classList.remove("pb-site-header__nav-secondary--sticky");
        }
      }
      if(!viewport.large && primaryHeader) {
          let sticky = primaryHeader.offsetTop;
          if (window.pageYOffset > sticky) {
            if(header) header.classList.remove("pb-site-header__nav-secondary--sticky");
            primaryHeader.classList.add("pb-site-header__primary-container--sticky");
          } else {
            primaryHeader.classList.remove("pb-site-header__primary-container--sticky");
          }
      }
    }
  }

  onMenuToggle = () => {
    if(!this.props.menuSelected || this.props.menuSelected !== menuPageSelected.main) {
      this.props.updateActiveMenuSelected(menuPageSelected.main)
      this.props.bottomMenuSelected('')
      window.scrollTo(0, 0);
      this.onTriggerEvents({
        gaEvent: 'clicked_menu',
        gaCategory: gaEventCategories.navigation,
        gaLabel: gaEventLabel.mobileApp
      })
    }
    else{
      this.props.updateActiveMenuSelected('')
      this.props.bottomMenuSelected('')
    }
  }

  mobSiteLangClick = () => {
    if(!this.props.menuSelected || this.props.menuSelected !== menuPageSelected.mobSiteLang) {
      this.props.updateActiveMenuSelected(menuPageSelected.mobSiteLang)
      this.props.bottomMenuSelected('')
    }
    else {
      this.props.updateActiveMenuSelected('')
      this.props.bottomMenuSelected('')
    }
  }

  handleClose = () => {
    this.props.updateActiveMenuSelected('')
    this.props.bottomMenuSelected('')
  }

  handleClickOutside = () => {
  }

  onSelect = (val, id) => {
    this.props.updateWordSearchFrequencyWorkFlow(id)
    .then(() => {
      this.onTriggerEvents({
        gaEvent: gaEventActions.clickedSearch,
        gaCategory: gaEventCategories.navigation,
        gaLabel: gaEventActions.search,
        itemType: gaEventLabel.searchTerm,
        itemValue: val
      });
      window.location.href = links.searchBy(val)
    })
  }


  onLogout = () => {
    this.props.logout()
      .then(() => {
        window.location.href = this.props.user.redirectOnLogOut || links.home()
        localStorage.setItem('sw-log-in-out-activity', 'logout' + Math.random());
        localStorage.removeItem('userName');
        localStorage.removeItem('userId');
        localStorage.removeItem('profileType');
      })
  }

  isActive = (child) => {
    if (child.props.href && window.location.pathname.includes(child.props.href.split('?')[0])) {
      return React.cloneElement(child, {
        active: true
      });
    }

    return child;
  }

  onOpenSearchModal = () => {this.setState({ isSearchModalOpen: true })}
  onCloseSearchModal = () => this.setState({ isSearchModalOpen: false })

  onSearch = (query) => {
    if (query) {
      this.props.addNewSearchWordWorkFlow(query)
      .then((res) => {
        if(res.ok) {
          this.onTriggerEvents({
            gaEvent: gaEventActions.clickedSearch,
            gaCategory: gaEventCategories.navigation,
            gaLabel: gaEventActions.search,
            itemType: gaEventLabel.searchTerm,
            itemValue: query
          });
          window.location.href = links.searchBy(query)
        }  
        else {
          this.props.addSlimNotification({
            id: "global-auto-suggest",
            content: res.data.errorMessage
          });
          return;
        }      
      })
    }
    else {
      const { user: { languagePreferences, readingLevels }} = this.props;
      window.location.href = links.allBooks(void 0, languagePreferences, readingLevels);
    }
  }

  onCreateClicked = () => {
    const { viewport, addSlimNotification, isLoggedIn, openAuthModal, t } = this.props;

    if (!isLoggedIn) {
      openAuthModal();
      return;
    }

    if (!this.props.user.emailConfirmed) {
      addSlimNotification({
        id: "OTP.confirm-email-action",
        content: t('OTP.confirm-email-action', { action: t('global.create-storybooks') })
      });
      return;
    }

    if (viewport.medium) {
      let el = document.getElementsByTagName("body")[0]
      if(el) {
        el.style.opacity = 0.5;
        el.style.pointerEvents = "none";
      }
      this.setState({loading : true})
      window.location.href = links.create();
    } else {
      addSlimNotification({
        id: 'Book.mobile-editor-notification',
        content: t('Book.mobile-editor-notification-text'),
      });
    }
  }

  fetchBookFilters = () => {
    if(!this.props.filters) this.props.fetchAllListsFiltersWorkflow();
  }

  fetchTrendingThemes = () => {
    if(this.props.isTrendingTheme) 
    this.props.fetchTrendingThemesWorkflow();
    this.props.fetchAllReadalongFiltersWorkflow()
  }

  onBookshelfGaEventCall = () => {
    window.dataLayer.push({
      'event': gaEventActions.bookshelfClicked,
      'category': gaEventCategories.bookShelf,
      'label': gaEventCategories.homePage,
      'item_type': null,
      'item_id': null,
      'item_value': null,
      'user_id': this.props.user.id,
      'user_profile': this.props.user.profile_type,
    });
  }

  getLanguage = (lang) => {
    let langEl = appLanguages.filter(el => el.queryValue === lang)[0]
    return langEl.name
  }

  onTriggerEvents = (obj) => {
    const {gaEvent, gaCategory, gaLabel, itemType, itemValue} = obj;
    window.dataLayer.push({
      'category': gaCategory,
      'event': gaEvent,
      'label': gaLabel,
      'item_type': itemType || null,
      'item_value': itemValue || null, 
      'item_id': null,
      'user_profile': this.props.user.profile_type,
      'user_id': this.props.user.id,
    })
  }

  triggerLogoEvents = () => {
    window.dataLayer.push({
      'category': gaEventCategories.navigation,
      'event': gaEventActions.clickedLogo,
      'label': gaEventCategories.homePage,
      'item_type': null,
      'item_id': null,
      'item_value': null,
      'user_id': this.props.user.id,
      'user_profile': this.props.user.profile_type,
    });
  }

  handleGcrMobMenu = (options, list) => {
    const {isLoggedIn, localePreferences, updateActiveMenuSelected}=this.props;

    if (options.length <= 0 || !isLoggedIn) {
      this.gcrEvents(gaEventLabel.storyweaverGcr);
      window.location.href=links.pledgeToRead(localePreferences ? localePreferences : siteLocale)
    }
    else if (list && options.length === 1) {
      this.gcrEvents(options[0].id);
      window.location.href=options[0].url
    }
    else {
      updateActiveMenuSelected(menuPageSelected.gcr);
    }
  }

  gcrEvents = (label) => {
    this.onTriggerEvents({
      gaEvent: gaEventActions.clickedGcr,
      gaCategory: gaEventCategories.navigation,
      gaLabel: `${label}-gcr`
    })
  }

  render() {
    const baseClassName = 'pb-site-header';
    const classNames = [baseClassName];
    const {
            t,
            isLoggedIn,
            user,
            user: { languagePreferences, readingLevels },
            isFetchingMe,
            viewport,
            offline,
            openAuthModal,
            updateActiveDropdownLink,
            updateActiveMenuSelected,
            activeDropdown,
            menuSelected,
            isBottomMenuSelected,
            isRtl,
            filters,
            fetchAutoSuggestionsWorkflow,
            autoSuggestions,
            searchQuery,
            platformNotifications,
            markAllNotificationsAsReadWorkflow,
            markOneNotificationsAsReadWorkflow,
            trendingThemes,
            raFilters,
            localePreferences,
            staticSubGcrData,
            addSlimNotification
          } = this.props;

    const { isSearchModalOpen } = this.state;

    let sortedAppLanguages , languageOptions = [];
    sortedAppLanguages = otherAppLanguages.sort((a , b ) => (a.queryValue > b.queryValue) ?1 : -1)
    languageOptions = [...defaultAppLanguages , ...sortedAppLanguages]

    if(isRtl) classNames.push(`${baseClassName}--rtl`)

    const newEl = <span className={`${baseClassName}__new-entry-point`}>{t("global.new")}</span> 

    const allLinks = [
      <Link key="opds-dashboard" fullWidth href={links.userOpdsDashboard()}>{t('global.opds-dashboard')}</Link>,
      <Link key="organisation-settings" fullWidth href={links.userOrgDetails(user.orgId)}>{t('global.organisation-settings')}</Link>,
      <Link key="content-manager-dashboard" fullWidth href={links.dashboard()}>{t('global.content-manager-dashboard')}</Link>,
      <Link key="contest-dashboard" fullWidth href={links.contests()}>{t('global.contest-dashboard')}</Link>,
      <Link key="blog-dashboard" fullWidth href={links.blogDashboard()}>{t('global.blog-dashboard')}</Link>,
      <Link key="rating-dashboard" fullWidth href={links.ratingDashboard()}>{t('global.rating-dashboard')}</Link>,
      <Link key="translation-dashboard" fullWidth href={links.translationDashboard()}>{t('global.translation-dashboard')}</Link>,
      <Link key="jotform-dashboard" fullWidth onClick={() => {
        if(!viewport.medium) {
          addSlimNotification({
            id: 'Book.mobile-editor-notification',
            content: "Jotform dashboard is accessible only on desktop/Laptop"
          });
        }
        else {
          window.location.href = links.jotformDashboard()
        }
      }}>{t('global.jotform-dashboard')}</Link>,
      <Link key="rate-a-story" fullWidth href={links.rateStory()}>{t('global.rate-a-story')}</Link>,
      <Link key="rate-a-illustration" fullWidth href={links.rateIllustration()}>{t('global.rate-a-illustration')}</Link>,
      <Link key="review-a-story" fullWidth href={links.unreviewedStories()}>{t('global.review-a-story')}</Link>,
      <Link key="translate-a-story" fullWidth href={links.untranslatedStories()}>{t('global.translate-a-story')}</Link>,
      <Link key="analytics" noSiteLocale fullWidth href={links.analytics()} shouldOpenNewPage>{t('global.analytics')}</Link>,
      <Link key="translation-analytics" fullWidth href={links.translationAnalytics()}>{t('global.analytics')}</Link>,
      <Link key="publisher-dashboard" fullWidth href={links.publisherDashboard()}>{t('global.publisher-dashboard')}</Link>,
      <Link key="publisher-analytics" fullWidth href={links.publisherAnalytics()}>{t('global.analytics')}</Link>
    ];

    const mapRoleToLinks = {
      content_manager: ['content-manager-dashboard', 'contest-dashboard', 'blog-dashboard', 'rating-dashboard', 'translation-dashboard', 'analytics', 'rate-a-story', 'rate-a-illustration'],
      promotion_manager: ['contest-dashboard', 'blog-dashboard'],
      partnerships_manager: ['analytics'],
      reviewer: ['rate-a-story'],
      translator: ['translate-a-story'],
      studio_team: ['jotform-dashboard'],
      editor: ['review-a-story'],
      translation_partner_admin: ["translation-dashboard","translation-analytics"],
      publisher: ['publisher-dashboard', "publisher-analytics"],
      org_admin:['organisation-settings'],
      illustration_reviewer: ['rate-a-illustration'],
      user: []
    }

    if (user.roles && !user.roles.includes("publisher") && !user.roles.includes("translation_partner_admin")){
      mapRoleToLinks.org_admin = mapRoleToLinks.org_admin.concat("opds-dashboard");
    }

    const optionalLinks = allLinks.filter(link => {
      if (!user.roles) {
        return false;
      }else{
        return user.roles.reduce((links, role) => {
          return links.concat(mapRoleToLinks[role])
        }, []).includes(link.key)
      }
    })

    const langPrefFilteredForReadAlong = (languagePreferences) => {
      if (languagePreferences && raFilters) {
        return languagePreferences.filter(lang => raFilters.map(el => el.queryValue).includes(lang));
      }
    };

    let resourcesContent =  [ 
      <SiteNavLink key="stem" active={menuSelected === menuPageSelected.stem} variant="bordered" isRtl={isRtl} respondWidth fullWidth onHover={()=> viewport.large && updateActiveMenuSelected(menuPageSelected.stem)} onClick={()=> {updateActiveMenuSelected(menuPageSelected.stem)}} >
        <div className={`${baseClassName}__align`}>
          {t("global.stem")}
          <div className={`${baseClassName}__sub-text`}>{t("global.stem-grades")} | {t("global.stem-subjects")}</div>
        </div>
        <SvgIcon name={isRtl ? "chevron-left" : "chevron-right"} title={t('SvgTitle.chevron-right')}/>
      </SiteNavLink>,
      <MenuDivider key="stem-divider-1" variant="padding"/>,
      <SiteNavLink key="flp-home" active={menuSelected === menuPageSelected.flpHome} variant="bordered" isRtl={isRtl} respondWidth fullWidth onHover={()=> viewport.large && updateActiveMenuSelected(menuPageSelected.flpHome)} onClick={()=> updateActiveMenuSelected(menuPageSelected.flpHome)} >
        <div className={`${baseClassName}__align`}>
          {t("global.flp-home")}
          <div className={`${baseClassName}__sub-text`}>{t("global.levels")} {newEl}</div>
        </div>
        <SvgIcon name={isRtl ? "chevron-left" : "chevron-right"} title={t('SvgTitle.chevron-right')}/>
      </SiteNavLink>,
      <MenuDivider key="divider-2" variant="padding"/>,
      <SiteNavLink key="ece" active={menuSelected === menuPageSelected.ece} variant="bordered" isRtl={isRtl} respondWidth fullWidth onHover={()=> viewport.large && updateActiveMenuSelected(menuPageSelected.ece)} onClick={()=> updateActiveMenuSelected(menuPageSelected.ece)}>
        <div className={`${baseClassName}__align`}>
          {t("global.ece")}
          <div className={`${baseClassName}__sub-text`}>{t("global.levels")}</div>
        </div>
        <SvgIcon name={isRtl ? "chevron-left" : "chevron-right"} title={t('SvgTitle.chevron-right')}/>
      </SiteNavLink>,
      <MenuDivider key="divider-3" variant="padding"/>,
      <SiteNavLink key="reading program" active={menuSelected === menuPageSelected.readingProgram} variant="bordered" isRtl={isRtl} respondWidth fullWidth onHover={()=> viewport.large && updateActiveMenuSelected(menuPageSelected.readingProgram)} onClick={()=> updateActiveMenuSelected(menuPageSelected.readingProgram)}>
        <div className={`${baseClassName}__align`}>
          {t("global.reading-program", 1)} 
          <div className={`${baseClassName}__sub-text`}>{t("global.grades")}</div>
        </div>
        <SvgIcon name={isRtl ? "chevron-left" : "chevron-right"} title={t('SvgTitle.chevron-right')}/>
      </SiteNavLink>,
      <MenuDivider key="divider-4" variant="padding"/>,
      <SiteNavLink key="lists" active={menuSelected === menuPageSelected.bookLists} variant="bordered" isRtl={isRtl} respondWidth fullWidth onClick= {()=> {updateActiveMenuSelected(menuPageSelected.bookLists); this.fetchBookFilters()}} 
      onHover={()=> {
        if(viewport.large) {
          updateActiveMenuSelected(menuPageSelected.bookLists);
          this.fetchBookFilters();
        }}}>
        <div className={`${baseClassName}__align`}>
          {t("global.book-lists")}
          <div className={`${baseClassName}__sub-text`}>{t("global.grades")}</div>
        </div>
        <SvgIcon name={isRtl ? "chevron-left" : "chevron-right"} title={t('SvgTitle.chevron-right')}/>
      </SiteNavLink>
    ];

    const readContent =  [ 
      <SiteNavLink key="level 1 emergent stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, [5])} >{t("global.emergent-readers")}</SiteNavLink>,
      <SiteNavLink key="level 1 stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, [1])} >{t("global.level-books", {level_no: 1})}</SiteNavLink>,
      <SiteNavLink key="level 2 stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, [2])} >{t("global.level-books", {level_no: 2})}</SiteNavLink>,
      <SiteNavLink key="level 3 stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, [3])} >{t("global.level-books", {level_no: 3})}</SiteNavLink>,
      <SiteNavLink key="level 4 stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, [4])} >{t("global.level-books", {level_no: 4})}</SiteNavLink>,
      <SiteNavLink key="all-stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, readingLevels)} >{t("global.all-book")}</SiteNavLink>,
    ];

    const readFormatContent =  [ 
      <SiteNavLink key="audio-stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allAudioBooks(void 0, langPrefFilteredForReadAlong(languagePreferences), readingLevels)} >{t("global.readalongs")}</SiteNavLink>,
      <SiteNavLink key="video" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.videos()} >{t("global.videos")}</SiteNavLink>,
      <SiteNavLink key="gif" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, readingLevels, void 0, ['gif'])} >{t("global.gif")}</SiteNavLink>,
    ];

    const readContentMobile =  [ 
      <SiteNavLink key="level 1 emergent stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, [5])} >{t("global.emergent-readers")}</SiteNavLink>,
      <SiteNavLink key="level 1 stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, [1])} >{t("global.level-books", {level_no: 1})}</SiteNavLink>,
      <SiteNavLink key="level 2 stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, [2])} >{t("global.level-books", {level_no: 2})}</SiteNavLink>,
      <SiteNavLink key="level 3 stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, [3])} >{t("global.level-books", {level_no: 3})}</SiteNavLink>,
      <SiteNavLink key="level 4 stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, [4])} >{t("global.level-books", {level_no: 4})}</SiteNavLink>,
      <SiteNavLink key="audio-stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allAudioBooks(void 0, langPrefFilteredForReadAlong(languagePreferences), readingLevels)} >{t("global.readalongs")}</SiteNavLink>,
      <SiteNavLink key="video" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.videos()} >{t("global.videos")}</SiteNavLink>,
      <SiteNavLink key="gif" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, readingLevels, void 0, ['gif'])} >{t("global.gif")}</SiteNavLink>,
      <SiteNavLink key="all-stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, readingLevels)} >{t("global.all-book")}</SiteNavLink>,
    ];


    const trendingThemesList =  trendingThemes.map(el => {
      return <SiteNavLink key={el.name} variant="bordered" respondWidth fullWidth alignLeft href={links.allBooks(void 0, languagePreferences, readingLevels, [el.queryValue])} title={el.name}>{el.name}</SiteNavLink>
    })

    const trendingLanguagesList =  trendingLanguages.map(el => {
      return <SiteNavLink key="el" variant="bordered" respondWidth fullWidth alignLeft href={links.allBooks(void 0, [el], readingLevels)} >{el}</SiteNavLink>
    })

    let gcrOptions = [];
    let allGcrs = staticSubGcrData ? [
      {
        name: "StoryWeaver's #GetChildrenReading", 
        logo: staticPageImages.campaigns.swLogo, 
        key: 'storyweaver', 
        url: links.pledgeToRead(localePreferences ? localePreferences : siteLocale),
        id: 'StoryWeaver'
      }, ...staticSubGcrData.map(el => (el.attributes && {
        name: el.attributes.menuPartnerName, 
        logo: el.attributes.menuPartnerLogo.data && el.attributes.menuPartnerLogo.data.attributes.url, 
        key: el.attributes.menuPartnerName,
        url: links.gcrSubCampaign((el.attributes.languageSupport.find(el => el.point === localePreferences) ? localePreferences : el.attributes.languageSupport.find(el => el.point === siteLocale) ? siteLocale : el.attributes.languageSupport[0].point) , el.attributes.partnerName),
        id: el.attributes.partnerName
      }))]
      : []

    user.ptrOrgs && user.ptrOrgs.length > 0 && user.ptrOrgs.forEach(el  => {
      if(el) {
        let x = allGcrs.find(elem => el === elem.id)
        if(x) gcrOptions.push(x)
      }
    })

    let gcrBlueSection = (<div className={`${baseClassName}__gcr-img`}><img className={`${baseClassName}__gcr-img--blink`} src={staticPageImages.campaigns.stars} alt={'gcr'} /> <span>{"#GetChildrenReading"}
    {(gcrOptions.length > 1 && viewport.large) && <Caret direction={"down"} parentClassName={`${baseClassName}__gcr-caret`}></Caret>}
    </span></div>)

    let gcrList =  gcrOptions && gcrOptions.length > 0 && gcrOptions.reverse().map(data=> {
        return <Link href={data.url} onClick={()=> this.gcrEvents(data.id)}>
          <span className={`${baseClassName}__gcr-menu`}>
            <img className={`${baseClassName}__gcr-menu--logo`} src={data.logo} alt="partner logo" />
            <p className={`${baseClassName}__gcr-menu--title`} title={data.name}>{data.name}</p>
          </span>
          <MenuDivider />
        </Link>
      })

    const gcrDropDown = (gcrOptions.length <= 0 || !isLoggedIn) ?
      <Link key="gcr" href={links.pledgeToRead(localePreferences ? localePreferences : siteLocale)} onClick={()=> this.gcrEvents(gaEventLabel.storyweaverGcr)}>{gcrBlueSection}</Link>
      :
      (gcrList && gcrList.length === 1) ?
      <Link key="gcr" href={gcrOptions[0].url} onClick={()=> this.gcrEvents(gcrOptions[0].id)}>{gcrBlueSection}</Link>
      :
      <Dropdown
      toggleEl= {gcrBlueSection}
      align={"left"}
      disabled={false}
      isRtl={false}
      noMargin
      variant="hover"
      updateActiveDropdownLink={updateActiveDropdownLink}
      activeDropdown={activeDropdown}
     >
      <List nowrap parentClassName={`${baseClassName}__create`}>
        {gcrList}
      </List>          
    </Dropdown>

    const bottomGcrMob = () => {
      if (gcrOptions.length <= 0 || !isLoggedIn) {
        this.gcrEvents(gaEventLabel.storyweaverGcr);
        window.location.href=links.pledgeToRead(localePreferences ? localePreferences : siteLocale)
      }
      else if(gcrList && gcrOptions.length === 1) {
        this.gcrEvents(gcrOptions[0].id);
        window.location.href=gcrOptions[0].url
      }
      else {
        return (<ExpandableMenu 
          content={gcrList} 
          rightIcon={isBottomMenuSelected && <div className={`${baseClassName}__gcr-close`} onClick={this.handleClose}><SvgIcon name="close" title={t('SvgTitle.close')}/></div>}
          backLinkContent={gcrBlueSection}
          baseClassName={baseClassName} 
          menuSelected={menuSelected} 
          updateActiveMenuSelected={updateActiveMenuSelected}
          isRtl={false} 
          t={t}
          parentClassName={`${baseClassName}__gcr-close`}/>)
      }
    } 

    let createList =  [
      <SiteNavLink key="create story" variant="bordered" isRtl={isRtl} respondWidth alignLeft newEl={this.state.loading && <Loader />} onClick={this.onCreateClicked} parentClassName={this.state.loading ? (isRtl ? `${baseClassName}__loader-space--rtl`: `${baseClassName}__loader-space`) : null}>{t("global.create", 1)}</SiteNavLink>,
      <SiteNavLink key="image" variant="bordered" isRtl={isRtl} respondWidth alignLeft href={links.allIllustrations()}>{t("global.image", 2)}</SiteNavLink>,
    ];

    const createDropDown = (
      <Dropdown
      toggleEl={<SiteNavLink key="create" variant="bordered" caret='down' noLeftPadding={true}>{t("global.create", 1)}</SiteNavLink>}
      align={isRtl ? "right" : "left"}
      disabled={false}
      isRtl={isRtl}
      noMargin
      bordered
      variant={!this.state.loading && "hover"}
      updateActiveDropdownLink={updateActiveDropdownLink}
      activeDropdown={activeDropdown}
     >
      <List nowrap parentClassName={`${baseClassName}__create`} alignRight={isRtl}>{createList}</List>          
    </Dropdown>
    );

    let discoverList =  [
      <SiteNavLink key="parent" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.parentHome()} active={window.location.href.includes(links.parentHome())} >{t("global.for-parents")}</SiteNavLink>,
      <SiteNavLink key="educator" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.educatorHome()} active={window.location.href.includes(links.educatorHome())} >{t("global.for-educators")}</SiteNavLink>,
      <SiteNavLink key="student" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.studentHome()} active={window.location.href.includes(links.studentHome())}>{t("global.for-students")}</SiteNavLink>,
    ];

    const discoverDropDown = (
      <Dropdown
      toggleEl={<SiteNavLink key="discover" variant="bordered" caret='down' noLeftPadding={true}>{t("global.discover")}</SiteNavLink>}
      align={isRtl ? "right" : "left"}
      disabled={false}
      isRtl={isRtl}
      noMargin
      bordered
      variant="hover"
      updateActiveDropdownLink={updateActiveDropdownLink}
      activeDropdown={activeDropdown}
     >
      <List nowrap parentClassName={`${baseClassName}__create`} alignRight={isRtl}>{discoverList}</List>          
    </Dropdown>
    );

      const readDropDown = (
      <Dropdown
      toggleEl={<SiteNavLink key="stories" variant="bordered" caret='down' noLeftPadding={true} onHover={()=>this.fetchTrendingThemes()}>{t("global.read", 1)}</SiteNavLink>}
      align={isRtl ? "right" : "left"}
      noPadding={true}
      disabled={false}
      isRtl={isRtl}
      minWidth="xxxl"
      noMargin
      bordered
      variant="hover"
      updateActiveDropdownLink={updateActiveDropdownLink}
      activeDropdown={activeDropdown}
     >
        <Columnizer noGutter bordered isRtl={isRtl}>
          <div className={`${baseClassName}__column`}>
            <div className={`${baseClassName}__column-heading`}>{t("global.trending-themes")} <SvgIcon name="trending" size="sm" title={t('SvgTitle.trending')}/></div>
            <List nowrap parentClassName={`${baseClassName}__column-list ${baseClassName}__trending-theme`} alignRight={isRtl}>{trendingThemesList}</List>
          </div>
          <div className={`${baseClassName}__column`}>
            <div className={`${baseClassName}__column-heading`}>{t("global.trending-languages")} <SvgIcon name="trending" size="sm" title={t('SvgTitle.trending')}/></div>
            <List nowrap parentClassName={`${baseClassName}__column-list`} alignRight={isRtl}>{trendingLanguagesList}</List>
          </div>  
          <div className={`${baseClassName}__column ${baseClassName}__column--light`}>
            <div>
              <div className={`${baseClassName}__column-heading`}>{t("global.explore-books")}</div>
              <List nowrap parentClassName={`${baseClassName}__column-list`} alignRight={isRtl}>{readContent}</List>
            </div>
            <div className={`${baseClassName}__column-section`}>
              <div className={`${baseClassName}__column-heading`}>{t("global.explore-formats")}</div>
              <List nowrap parentClassName={`${baseClassName}__column-list`} alignRight={isRtl}>{readFormatContent}</List>
            </div>
          </div>  
        </Columnizer>
      </Dropdown>
      );

      const readingProgramContent =  Object.entries(readingProgram.siteHeaderLinks).filter(([k, v])=> v.label === "English").concat(sortBy(Object.entries(readingProgram.siteHeaderLinks).filter(([k,v]) => v.label !== "English"), ([k,v]) => v.label))
      .map(([key, val]) =>  
        <SiteNavLink parentClassName={`${baseClassName}__drop-down-link`} key={val.value} variant="bordered" active={window.location.search.split("=")[1]===val.value && window.location.href.includes("reading-programme")} respondWidth href={`/reading-programme?language=${val.value}`}>{val.label}</SiteNavLink>
      )
      
      let bookListFilters = filters && filters.filter(el => el.name === "Language")[0].queryValues

      const bookListsContent =  bookListFilters && (bookListFilters.filter(el => el.queryValue === "English").concat(sortBy(bookListFilters.filter(el => el.queryValue !== "English"), el => el.queryValue)))
      .map(el => 
        <SiteNavLink parentClassName={`${baseClassName}__drop-down-link`} key={el.name} variant="bordered" respondWidth 
        active={queryString.parse(window.location.search).language===el.queryValue} 
        href={links.allLists({language: el.queryValue})}>{el.queryValue}</SiteNavLink>,               
      )

      const csfContent =  Object.entries(csf.siteHeaderLinks).map(([key, val]) => <SiteNavLink 
        parentClassName={`${baseClassName}__drop-down-link`} 
        key={`csf-${key}`} 
        variant="bordered" 
        respondWidth 
        active={queryString.parse(window.location.search).language===val.value && window.location.pathname.replace(`/${siteLocale}`, '').replace(/\/([^/]*).*$/, '$1') === 'foundational-literacy'} 
        href={links.csf(val.value)}
      >{val.label}</SiteNavLink>)

      const csfMobileContent = Object.entries(csf.siteHeaderLinks).map(([key, val]) => <SiteNavLink 
          key={`csf-${key}`} 
          variant="bordered" 
          fullWidth 
          alignLeft 
          active={queryString.parse(window.location.search).language===val.value && window.location.pathname.replace(`/${siteLocale}`, '').replace(/\/([^/]*).*$/, '$1') === 'foundational-literacy'} 
          respondWidth 
          href={links.csf(val.value)}
        >{val.label}</SiteNavLink>)

      const flpHomeContent = Object.entries(flpHome.siteHeaderLinks).filter(([k, v])=> v.label === "English").concat(sortBy(Object.entries(flpHome.siteHeaderLinks).filter(([k, v])=> v.label !== "English"), ([k,v]) => v.label))
      .map(([key, val]) => 
        <SiteNavLink 
          parentClassName={`${baseClassName}__drop-down-link`} 
          key={`flp-${key}`} 
          variant="bordered" 
          respondWidth 
          active={queryString.parse(window.location.search).language===val.value && window.location.pathname.replace(`/${siteLocale}`, '').replace(/\/([^/]*).*$/, '$1') === 'foundational-literacy-programme'} 
          href={links.flpHome(val.value)}
        >{val.label}</SiteNavLink>)

      const flpHomeMobileContent = Object.entries(flpHome.siteHeaderLinks).filter(([k, v])=> v.label === "English").concat(sortBy(Object.entries(flpHome.siteHeaderLinks).filter(([k, v])=> v.label !== "English"), ([k,v]) => v.label))
      .map(([key, val]) => 
        <SiteNavLink 
          key={`flp-${key}`}
          variant="bordered" 
          fullWidth 
          alignLeft 
          active={queryString.parse(window.location.search).language===val.value && window.location.pathname.replace(`/${siteLocale}`, '').replace(/\/([^/]*).*$/, '$1') === 'foundational-literacy-programme'} 
          respondWidth 
          href={links.flpHome(val.value)}
        >{val.label}</SiteNavLink>)

      const eceContent =  [
        <SiteNavLink 
          parentClassName={`${baseClassName}__drop-down-link`} 
          key="ece-hi" 
          variant="bordered" 
          respondWidth 
          active={queryString.parse(window.location.search).language===ece.siteHeaderLinks["hindi"].value && window.location.href.includes("early-learning-resources")} 
          href={links.ece(ece.siteHeaderLinks["hindi"].value)}
        >{ece.siteHeaderLinks["hindi"].label}</SiteNavLink>,
      ]

      const eceMobileContent = [
        <SiteNavLink 
          key="ece-hi" 
          variant="bordered" 
          fullWidth 
          alignLeft 
          active={queryString.parse(window.location.search).language===ece.siteHeaderLinks["hindi"].value && window.location.href.includes("early-learning-resources")} 
          respondWidth 
          href={links.ece(ece.siteHeaderLinks["hindi"].value)}
        >{ece.siteHeaderLinks["hindi"].label}</SiteNavLink>,
      ]

      const stemHomeContent = Object.entries(stemHome.siteHeaderLinks).filter(([k, v])=> v.disable === false)
      .map(([key, val]) => 
        <SiteNavLink 
          parentClassName={`${baseClassName}__drop-down-link`} 
          key={`stem-${key}`} 
          variant="bordered" 
          respondWidth 
          active={queryString.parse(window.location.search).language===val.value && window.location.pathname.replace(`/${siteLocale}`, '').replace(/\/([^/]*).*$/, '$1') === 'stem-literacy-programme'} 
          href={links.stemHome(val.value)}
        >{val.label}</SiteNavLink>)

      const stemHomeMobileContent = Object.entries(stemHome.siteHeaderLinks).filter(([k, v])=> v.disable === false)
      .map(([key, val]) => 
        <SiteNavLink 
          key={`stem-${key}`}
          variant="bordered" 
          fullWidth 
          alignLeft 
          active={queryString.parse(window.location.search).language===val.value && window.location.pathname.replace(`/${siteLocale}`, '').replace(/\/([^/]*).*$/, '$1') === 'stem-literacy-programme'}
          respondWidth 
          href={links.stemHome(val.value)}
        >{val.label}</SiteNavLink>)

      const resourcesDropDown = (
        <Dropdown
        toggleEl={<SiteNavLink key="resources" variant="bordered" caret='down' noLeftPadding={true}>{t("global.resources", 1)}</SiteNavLink>}
        align={isRtl ? "right" : "left"}
        noPadding={true}
        disabled={false}
        noMargin
        bordered
        variant="hover"
        minWidth={menuSelected ? "xxl" : "xl"}
        updateActiveMenuSelected={updateActiveMenuSelected}
        updateActiveDropdownLink={updateActiveDropdownLink}
        activeDropdown={activeDropdown}
        isRtl={isRtl}
       >
          {(menuSelected === menuPageSelected.readingProgram) ?
            <Columnizer noGutter bordered isRtl={isRtl} columns={['60%', '40%']}>
              <List parentClassName={`${baseClassName}__resources-column`} nowrap alignRight={isRtl}>{resourcesContent}</List>
              <List parentClassName={`${baseClassName}__resources-column ${baseClassName}__resources-column-list`} nowrap >{readingProgramContent}</List>
              </Columnizer>
            :
            (menuSelected === menuPageSelected.bookLists) ?
              <Columnizer noGutter bordered isRtl={isRtl} columns={['60%', '40%']}>
                <List parentClassName={`${baseClassName}__resources-column`} nowrap alignRight={isRtl}>{resourcesContent}</List>
                <List parentClassName={`${baseClassName}__resources-column ${baseClassName}__resources-column-list`} nowrap >{bookListsContent}</List>
              </Columnizer>
              :
            (menuSelected === menuPageSelected.csf) ?
              <Columnizer noGutter bordered isRtl={isRtl} columns={['60%', '40%']}>
                <List parentClassName={`${baseClassName}__resources-column`} nowrap alignRight={isRtl}>{resourcesContent}</List>
                <List parentClassName={`${baseClassName}__resources-column ${baseClassName}__resources-column-list`} nowrap >{csfContent}</List>
              </Columnizer>
            :
            (menuSelected === menuPageSelected.flpHome) ?
              <Columnizer noGutter bordered isRtl={isRtl} columns={['60%', '40%']}>
                <List parentClassName={`${baseClassName}__resources-column`} nowrap alignRight={isRtl}>{resourcesContent}</List>
                <List parentClassName={`${baseClassName}__resources-column ${baseClassName}__resources-column-list`} nowrap >{flpHomeContent}</List>
              </Columnizer>
            :
            (menuSelected === menuPageSelected.ece) ?
              <Columnizer noGutter bordered isRtl={isRtl} columns={['60%', '40%']}>
                <List parentClassName={`${baseClassName}__resources-column`} nowrap alignRight={isRtl}>{resourcesContent}</List>
                <List parentClassName={`${baseClassName}__resources-column ${baseClassName}__resources-column-list`} nowrap >{eceContent}</List>
              </Columnizer>
            :
            (menuSelected === menuPageSelected.stem) ?
              <Columnizer noGutter bordered isRtl={isRtl} columns={['60%', '40%']}>
                <List parentClassName={`${baseClassName}__resources-column`} nowrap alignRight={isRtl}>{resourcesContent}</List>
                <List parentClassName={`${baseClassName}__resources-column ${baseClassName}__resources-column-list`} nowrap >{stemHomeContent}</List>
              </Columnizer>
            :
            <Columnizer noGutter bordered isRtl={isRtl}>
              <List parentClassName={`${baseClassName}__resources-column`} nowrap alignRight={isRtl}>{resourcesContent}</List>
            </Columnizer>
          }
        </Dropdown>
      );

      

      const languageSelectionDropdownMobile = (
        <List nowrap>{languageOptions.map(language => {
            return (
              <SiteNavLink parentClassName={`${baseClassName}__drop-down-link ${baseClassName}__link--ltr ${baseClassName}__site-lang--dropdown`} key={language.queryValue} alignLeft={true} isIcon onClick={() => this.props.changeLanguage(language.queryValue)} respondWidth>
                {/* <span className="pb-site-header__language"><span className="pb-site-header__language-value">{language.queryValue}</span></span> */}
                {language.name}
              </SiteNavLink>
            )
          })}
        </List>
      )
        const languageDropdown = languageOptions.map(language => {
          return (
            <SiteNavLink parentClassName={`${baseClassName}__drop-down-link ${baseClassName}__site-lang`} key="languages" variant="bordered" isIcon onClick={() => this.props.changeLanguage(language.queryValue)} respondWidth>
              {/* <span className="pb-site-header__language">
              <span className="pb-site-header__language-value">{language.queryValue}</span>
              </span> */}
              {language.name}</SiteNavLink>
          )
        });

        const languageSelectionDropDown = (
          offline 
            ?
          <SiteNavLink noLeftPadding={true} disabled uppercase>{this.state.dropdownSelectedLanguage}</SiteNavLink>
            :
          <Dropdown
            toggleEl={<SiteNavLink caret='down' noLeftPadding={true} >{this.getLanguage(this.state.dropdownSelectedLanguage)}</SiteNavLink>}
            disabled={false}
            variant="hover"
            updateActiveDropdownLink={updateActiveDropdownLink}
            activeDropdown={activeDropdown}
            isRtl={isRtl}
            verticalPadding
          >
            <List nowrap parentClassName={`${baseClassName}__rp-drop-down`}>{languageDropdown}</List>
          </Dropdown>
        );

        const languageSelectionMobDropDown = (
          <SiteNavLink caret={this.props.menuSelected === menuPageSelected.mobSiteLang ? 'up': 'down'} parentClassName={`${baseClassName}__site-lang--mob`} onClick={()=> this.mobSiteLangClick()} smallLineHeight={!viewport.large} noLeftPadding={true} >{this.getLanguage(this.state.dropdownSelectedLanguage)}</SiteNavLink>
        );

    let siteNavLinks = [
      <SiteNavLink key="read dropdown" variant="bordered">{readDropDown}</SiteNavLink>,
      <SiteNavLink key="translate" variant="bordered" respondWidth href={links.translate()}>{t("global.translate")}</SiteNavLink>,      
      <SiteNavLink key="create" variant="bordered" respondWidth>{createDropDown}</SiteNavLink>,
      <SiteNavLink key="resources" variant="bordered" respondWidth ><span className={`${baseClassName}__new-entry-wrapper`}>{resourcesDropDown} {newEl}</span></SiteNavLink>,
      <SiteNavLink key="discover" variant="bordered" respondWidth>{discoverDropDown}</SiteNavLink>,
      <SiteNavLink key="donate" href={links.donate()} parentClassName={`${baseClassName}__donate`}>{t("global.donate")}</SiteNavLink>,
      <SiteNavLink key="gcr" parentClassName={window.location.pathname.replace(`/${siteLocale}`, '')===`/donate` ? `${baseClassName}__gcr ${baseClassName}__gcr-donate` : `${baseClassName}__gcr`}><span className={`${baseClassName}__gcr-tp`}>{gcrDropDown}{user.showPtrFirstPopUp && (window.location.pathname === links.home() || window.location.pathname === links.studentHome() || window.location.pathname === links.parentHome() || window.location.pathname === links.educatorHome()) && <Suspense fallback={null}><PTRTooltip /></Suspense>}</span></SiteNavLink>,
    ]

    if (window.location.pathname.replace(`/${siteLocale}`, '')===`/donate`) {
      siteNavLinks = siteNavLinks.filter(l => l.key !=='donate')
    }

    let showGcr = window.location.pathname.replace(`/${siteLocale}`, '') === '/about/campaigns/getchildrenreading' || window.location.pathname.replace(`/${siteLocale}`, '') === '/about/campaigns/getchildrenreading/pcertificate' || window.location.pathname.replace(`/${siteLocale}`, '') === '/about/campaigns/getchildrenreading/partner' || window.location.pathname.replace(`/${siteLocale}`, '') === '/about/campaigns/getchildrenreading/odoscertificate'

    if (showGcr) {
      siteNavLinks = siteNavLinks.filter(l => l.key !=='gcr')
    }

    const readingProgramMobileContent = Object.entries(readingProgram.siteHeaderLinks).filter(([key, val])=> val.label === "English").concat(sortBy(Object.entries(readingProgram.siteHeaderLinks).filter(([key,val]) => val.label !== "English"), ([key,val]) => val.label))
    .map(([key, val]) =>  
      <SiteNavLink key={val.value} variant="bordered" fullWidth alignLeft active={window.location.search.split("=")[1]===val.value && window.location.href.includes("reading-programme")} respondWidth href={`/reading-programme?language=${val.value}`}>{val.label}</SiteNavLink> 
    )

    const bookListsMobileContent = bookListFilters && (bookListFilters.filter(el => el.queryValue === "English").concat(sortBy(bookListFilters.filter(el => el.queryValue !== "English"), el => el.queryValue)))
      .map(el => 
        <SiteNavLink key={el.name} variant="bordered" fullWidth alignLeft respondWidth 
          active={queryString.parse(window.location.search).language===el.queryValue} 
          href={links.allLists({language: el.queryValue})}>{el.queryValue}</SiteNavLink>,
      )

    let gcrLinks = showGcr ?
    [ ]
    :
    window.location.pathname.replace(`/${siteLocale}`, '').includes('/getchildrenreading') ?
    [
      <SiteNavLink key="gcr" variant="bordered" respondWidth fullWidth alignLeft isRtl={isRtl} onClick= {()=> this.handleGcrMobMenu(gcrOptions, gcrList) } parentClassName={`${baseClassName}__gcr`}>
      {gcrBlueSection}
      {gcrOptions.length > 1 && <SvgIcon parentClassName={`${baseClassName}__gcr-close`} name={isRtl ? "chevron-left" : "chevron-right"} />}
      </SiteNavLink>,
      <MenuDivider key="divider-6" variant="padding"/>,
    ]
    :
    [
      <SiteNavLink key="language dropdown" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft onClick= {()=>{updateActiveMenuSelected(menuPageSelected.siteLang)}}>
        {t("global.site-language")} : {this.getLanguage(this.state.dropdownSelectedLanguage)} <SvgIcon name={isRtl ? "chevron-left" : "chevron-right"} title={isRtl ? t('SvgTitle.chevron-left') : t('SvgTitle.chevron-right')}/>
      </SiteNavLink>,
      <MenuDivider key="divider-6" variant="padding"/>,
      <SiteNavLink key="gcr" variant="bordered" respondWidth fullWidth alignLeft isRtl={isRtl} onClick= {()=> this.handleGcrMobMenu(gcrOptions, gcrList) } parentClassName={`${baseClassName}__gcr`}>
      {gcrBlueSection}
      {gcrOptions.length > 1 && <SvgIcon parentClassName={`${baseClassName}__gcr-close`} name={isRtl ? "chevron-left" : "chevron-right"} />}
      </SiteNavLink>,
      <MenuDivider key="divider-7" variant="padding"/>,
    ]

    let siteNavLinksMobile = [
      <SiteNavLink key="stories" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft onClick= {()=>{this.props.fetchAllReadalongFiltersWorkflow(); updateActiveMenuSelected(menuPageSelected.read);}}>
        {t("global.read", 1)} <SvgIcon name={isRtl ? "chevron-left" : "chevron-right"} title={isRtl ? t('SvgTitle.chevron-left') : t('SvgTitle.chevron-right')}/></SiteNavLink>,
      <MenuDivider key="divider-1" variant="padding"/>,
      <SiteNavLink key="translate" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.translate()} >{t("global.translate")}</SiteNavLink>,
      <MenuDivider key="divider-2" variant="padding"/>,
      <SiteNavLink key="resources" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft onClick= {()=>{updateActiveMenuSelected(menuPageSelected.resources);}}>
        <span className={`${baseClassName}__new-entry-wrapper`}>{t("global.resources")} {newEl}</span> <SvgIcon name={isRtl ? "chevron-left" : "chevron-right"} title={isRtl ? t('SvgTitle.chevron-left') : t('SvgTitle.chevron-right')}/></SiteNavLink>,
      <MenuDivider key="divider-8" variant="padding"/>,
      <SiteNavLink key="discover" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft onClick= {()=>{updateActiveMenuSelected(menuPageSelected.discover);}}>
        {t("global.discover")} <SvgIcon name={isRtl ? "chevron-left" : "chevron-right"} title={isRtl ? t('SvgTitle.chevron-left') : t('SvgTitle.chevron-right')}/></SiteNavLink>,
      <MenuDivider key="divider-3" variant="padding"/>,
      <SiteNavLink key="offline-library" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.offlineBooks()}>{t("global.offline-library", 2)}</SiteNavLink>,
      <MenuDivider key="divider-4" variant="padding"/>,
      <SiteNavLink key="image" variant="bordered" isRtl={isRtl} respondWidth fullWidth alignLeft href={links.allIllustrations()} >{t("global.image", 2)}</SiteNavLink>,
      <MenuDivider key="divider-5" variant="padding"/>,
      ...gcrLinks,
      <SiteNavLink key="donate" fullWidth alignLeft href={links.donate()} parentClassName={`${baseClassName}__donate`}>{t("global.donate")}</SiteNavLink>,
      <MenuDivider key="divider-8" variant="padding"/>,
      <SiteNavLink key="create" variant="sublinks" isRtl={isRtl} respondWidth alignLeft={!isRtl} onClick={this.onCreateClicked}>{t("global.create")}</SiteNavLink>,
    ]

    siteNavLinks = siteNavLinks.map(this.isActive);

    siteNavLinksMobile = siteNavLinksMobile.map(this.isActive);

    createList = createList.map(this.isActive);

    if (menuSelected && !viewport.medium) {
      if (!isBottomMenuSelected) classNames.push(`${baseClassName}--menu-open`);
      else classNames.push(`${baseClassName}--bottom-menu-open`);
    }

    let userLinkEls;
    if (isLoggedIn && viewport.large) {
      if(optionalLinks.length > 0){
        optionalLinks.unshift(
          <div key="spacer" className={`${baseClassName}__drop-down-spacer`}></div>
        );
        optionalLinks.push(
          <div key="spacer" className={`${baseClassName}__drop-down-spacer`}></div>
        );
      };
      userLinkEls = [
        <Link key="bookshelf" fullWidth href={links.userProfileBookShelf(user.id)} onClick={this.onBookshelfGaEventCall}>{t('global.bookshelf')}</Link>,
        // <Link key="profile" fullWidth href={links.userProfile(user.id)}>{t('global.edit-profile', 1)}</Link>,
        <Link key="dashboard" fullWidth href={links.profileDashboard()}>{t('global.dashboard')}</Link>,
        <Link key="userProfile" fullWidth href={links.editProfile()} >{t('Profile.edit-profile')}</Link>,
        ...optionalLinks,
        <Link onClick={this.onLogout} key="sign-out" fullWidth>{t('global.sign-out')}</Link>
      ];
    }

    let userLinkElsMobile;
    if (isLoggedIn && !viewport.large) {
      if(optionalLinks.length > 0){
        optionalLinks.unshift(
          <div className={`${baseClassName}__sub-section-header`}>{t('global.my-organization')}</div>,
        );
        optionalLinks.unshift(
          <MenuDivider />
        );
      };
      userLinkElsMobile = [
        <div className={`${baseClassName}__sub-section-header`}>{t('global.my-account')}</div>,
        <Link key="bookshelf" fullWidth href={links.userProfileBookShelf(user.id)} onClick={this.onBookshelfGaEventCall}>{t('global.bookshelf')}</Link>,
        // <Link key="profile" fullWidth href={links.userProfile(user.id)}>{t('global.edit-profile', 1)}</Link>,
        <Link key="dashboard" fullWidth href={links.profileDashboard()}>{t('global.dashboard')}</Link>,
        <Link key="userProfile" fullWidth href={links.editProfile()} >{t('Profile.edit-profile')}</Link>,
        ...optionalLinks,
        <MenuDivider key="divider"/>,
        <Link onClick={this.onLogout} key="sign-out" fullWidth>{t('global.sign-out')}</Link>
      ];
    }

    let userInfoEls;
    if (isLoggedIn) {
      userInfoEls = (
        viewport.large ?
        <Dropdown
          toggleEl={<SiteNavLink parentClassName={isRtl ? `${baseClassName}__dropdown-link` : null} noLeftPadding={isRtl} respondFontSize truncateTitle={this.state.truncateTitle}  title={user.first_name} caret='down' borderLeft smallFont >{user.first_name}</SiteNavLink>}
          parentClassName={`${baseClassName}__dropdown ${baseClassName}__first-name`}
          toggleClassName={`${baseClassName}__dropdown-toggle`}
          isRtl={isRtl}>
          <List nowrap alignRight={isRtl}>{userLinkEls}</List>
        </Dropdown>
        :
          <div><SvgIcon name="user" variant="circular-white" pushRight={!isRtl} pushLeft={isRtl} title={t('SvgTitle.user')}/>{t("global.welcome")}, {user.first_name} !</div>   
      );
    } else {
      userInfoEls = (
        viewport.large ?
        <SiteNavLink key="sign-up-log-in" parentClassName={`${baseClassName}__link-placeholder`} truncateTitle={this.state.truncateTitle} title={t("global.sign-up-log-in")} respondFontSize onClick={openAuthModal} borderLeft={viewport.medium} smallFont>
          {isFetchingMe ?
            <Loader />
            :
            <Fragment>
              <SvgIcon name="user" variant={viewport.medium ? "circular" : "circular-white"} pushRight title={t('SvgTitle.user')}/>
              {t("global.sign-up-log-in")}
            </Fragment>
          }
        </SiteNavLink>
        :
        <div onClick={openAuthModal} className={`${baseClassName}__signup`}><SvgIcon name="user" variant="circular-white" pushRight={!isRtl} pushLeft={isRtl} title={t('SvgTitle.user')}/>{t("global.sign-up-log-in")}</div>
      );
    }

    if (offline) {
      const userName = localStorage.getItem('userName');
      userInfoEls =  userName ? <SiteNavLink truncateTitle={this.state.truncateTitle}   disabled respondFontSize borderLeft>{userName}</SiteNavLink> : null
    }

    const offlineNavEl = (
      <SiteNavLink
        isInternal
        href={links.offlineBooks()}
        respondWidth={!offline}
        title={t("global.offline-library", 2)}
        variant={this.props.viewport.large ? 'default' : 'bordered'}
        disabled={!('serviceWorker' in navigator)}
        isIcon={true}
        smallFont
        truncateTitle={this.state.truncateTitle} 
        smallLineHeight={!viewport.large}
      >
        {
          this.props.isUpdatingRPBooks
            ?
            <Loader />
            :
            <span id="offline-library">
              <SvgIcon variant={window.location.pathname.includes('/offline') ? 'accent' : null} pushRight name="offline" title={t('SvgTitle.header-offline')} size="m" />{viewport.large ? t("global.offline-library") : null}
            </span>
        }
      </SiteNavLink>
    );

    const url = window.location.host
    //check
    const subDomain = url.split('.')[0]

    const autoSuggestionEl = (
      <AutoSuggestionsEl 
        autoSuggestions={autoSuggestions}
        fetchAutoSuggestionsWorkflow={fetchAutoSuggestionsWorkflow}
        onSearch={this.onSearch} 
        baseClassName={baseClassName}
        onSelect={this.onSelect}
        searchQuery={searchQuery}
        t={t}
        placeholder={t("global.search-topics")}
        />
    )

    let platformNotificationEl;
    if (isLoggedIn && !offline) {
      platformNotificationEl = (
        <SiteNavLink key="notification" borderLeft smallLineHeight={!viewport.large}> 
          {platformNotifications != null ? 
            <Suspense fallback={null}>
              <SiteNotification data={platformNotifications}
                markAllAsRead={markAllNotificationsAsReadWorkflow}
                markOneAsRead={markOneNotificationsAsReadWorkflow}
                viewport={viewport}
                user={user}
                />
            </Suspense>
            : <Loader /> }
        </SiteNavLink>
      )
    }

    return (
      <div className={classNames.join(' ')}>
        {  subDomain === subDomains.ddl ? <Suspense fallback={null}><DdlSiteHeader redirectOnLogOut={this.props.user.redirectOnLogOut} viewport={viewport} user={this.props.user} /></Suspense> : null }
        {  subDomain === subDomains.gd ? <Suspense fallback={null}><GdSiteHeader redirectOnLogOut={this.props.user.redirectOnLogOut} viewport={viewport} user={this.props.user} /></Suspense>  : null }

        <div className={`${baseClassName}__container`}>
            <div className={`${baseClassName}__primary-container`}>
              {
              (!isBottomMenuSelected) && 
              <div className={`${baseClassName}__brand`}>
                <Logo href={offline ? null : links.home()} parentClassName={`${baseClassName}__logo`} triggerLogoEvents={this.triggerLogoEvents} />
              </div>}
              {!offline && viewport.large &&
                <div className={`${baseClassName}__suggestion-el`}>{autoSuggestionEl}</div> 
              }
              {
              (!isBottomMenuSelected) && 
              <div className={`${baseClassName}__nav-primary`}>
                {(!viewport.large && !window.location.pathname.includes('/getchildrenreading'))  ? languageSelectionMobDropDown : null}
                {!offline && !viewport.large ? 
                  <SiteNavLink onClick={this.onOpenSearchModal} borderLeft={true} smallLineHeight={!viewport.large}>
                    <SvgIcon name="search" title={t('SvgTitle.search')} size="m"/>
                  </SiteNavLink> : null}

                {this.props.viewport.large || offline ? offlineNavEl : null}

                {(!this.props.viewport.large) ? null : userInfoEls }

                { this.props.viewport.large && !window.location.pathname.includes('/getchildrenreading') ? <SiteNavLink key="language dropdown" variant="bordered" borderLeft smallFont>{languageSelectionDropDown}</SiteNavLink> : null }
                
                {viewport.large ? platformNotificationEl : null}
                
                {
                  this.props.viewport.large || offline
                  ?
                  null
                  :
                  <SiteNavLink onClick={this.onMenuToggle} borderLeft={true} smallLineHeight={!viewport.large}><SvgIcon name={menuSelected && menuSelected !== menuPageSelected.mobSiteLang ? "close" : "menu"} title={menuSelected ? t('SvgTitle.close') : t('SvgTitle.menu')} size="m" /></SiteNavLink>
                }
              </div>}
              </div>
              {!offline && isSearchModalOpen
                ?
                <Suspense fallback={null}>
                  <SearchModal
                    viewport={viewport}
                    onClose={this.onCloseSearchModal}
                    onSubmit={this.onSearch}
                    onSelect={this.onSelect}
                    isRtl={isRtl}
                    fetchAutoSuggestionsWorkflow={fetchAutoSuggestionsWorkflow}
                    autoSuggestions={autoSuggestions}
                    searchQuery={searchQuery}
                  />
                </Suspense>
                :
                null}
             
              {
              menuSelected || viewport.medium
                ?            
                (offline
                  ?
                  null
                  :
                  (
                    <div className={(isRtl && ( viewport.medium && (menuSelected !== menuPageSelected.gcr || menuSelected !== menuPageSelected.bottomGcr))) ? `${baseClassName}__nav-secondary ${baseClassName}__nav-secondary--rtl` : `${baseClassName}__nav-secondary`}>
                      {
                        this.props.viewport.large
                        ?
                        siteNavLinks
                        :
                        <div> 
                          {(menuSelected === menuPageSelected.main) && 
                            <ExpandableMenu 
                              content={siteNavLinksMobile} 
                              goBackTo={isLoggedIn ? "user" : null} 
                              backLinkContent={userInfoEls} 
                              rightIcon={isLoggedIn && <SvgIcon name={isRtl ? "chevron-left" : "chevron-right"} title={isRtl ? t('SvgTitle.chevron-left') : t('SvgTitle.chevron-right')}/>} 
                              baseClassName={baseClassName}
                              menuSelected={menuSelected} 
                              updateActiveMenuSelected={updateActiveMenuSelected}
                              isRtl={isRtl} 
                              t={t}/>
                          }
                          {(menuSelected === menuPageSelected.user) &&
                              <ExpandableMenu 
                                content={<List nowrap parentClassName={`${baseClassName}__user`} alignRight={isRtl}>{userLinkElsMobile}</List>} 
                                backLinkContent={<div><SvgIcon name={isRtl ? "chevron-right" : "chevron-left"} title={isRtl ? t('SvgTitle.chevron-right') : t('SvgTitle.chevron-left')} pushRight={!isRtl} pushLeft={isRtl}/>{t("global.back-to-main")}</div>} 
                                goBackTo={menuPageSelected.main} 
                                baseClassName={baseClassName} 
                                menuSelected={menuSelected} 
                                updateActiveMenuSelected={updateActiveMenuSelected} 
                                isRtl={isRtl} 
                                onTriggerEvents={this.onTriggerEvents}
                                eventAction={gaEventLabel.backMenu}
                                eventLabel={menuPageSelected.user}
                                t={t}/>
                                }
                              {(menuSelected === menuPageSelected.read) &&
                                <ExpandableMenu 
                                  content={readContentMobile} 
                                  backLinkContent={<div><SvgIcon name={isRtl ? "chevron-right" : "chevron-left"} title={isRtl ? t('SvgTitle.chevron-right') : t('SvgTitle.chevron-left')} pushRight={!isRtl} pushLeft={isRtl}/>{t("global.back-to-main")}</div>} 
                                  goBackTo={menuPageSelected.main} 
                                  baseClassName={baseClassName} 
                                  menuSelected={menuSelected} 
                                  updateActiveMenuSelected={updateActiveMenuSelected} 
                                  isRtl={isRtl} 
                                  onTriggerEvents={this.onTriggerEvents}
                                  eventAction={gaEventLabel.backMenu}
                                  eventLabel={menuPageSelected.read}
                                  t={t}/>
                                  }
                              {(menuSelected === menuPageSelected.resources) &&
                                <ExpandableMenu 
                                  content={resourcesContent} 
                                  backLinkContent={<div><SvgIcon name={isRtl ? "chevron-right" : "chevron-left"} title={isRtl ? t('SvgTitle.chevron-right') : t('SvgTitle.chevron-left')} pushRight={!isRtl} pushLeft={isRtl}/>{t("global.back-to-main")}</div>} 
                                  goBackTo={menuPageSelected.main} 
                                  baseClassName={baseClassName} 
                                  menuSelected={menuSelected} 
                                  updateActiveMenuSelected={updateActiveMenuSelected} 
                                  isRtl={isRtl} 
                                  onTriggerEvents={this.onTriggerEvents}
                                  eventAction={gaEventLabel.backMenu}
                                  eventLabel={menuPageSelected.resources}
                                  t={t}/>
                                  }
                              {(menuSelected === menuPageSelected.discover) &&
                                <ExpandableMenu 
                                  content={discoverList} 
                                  backLinkContent={<div><SvgIcon name={isRtl ? "chevron-right" : "chevron-left"} title={isRtl ? t('SvgTitle.chevron-right') : t('SvgTitle.chevron-left')} pushRight={!isRtl} pushLeft={isRtl}/>{t("global.back-to-main")}</div>} 
                                  goBackTo={menuPageSelected.main} 
                                  baseClassName={baseClassName} 
                                  menuSelected={menuSelected} 
                                  updateActiveMenuSelected={updateActiveMenuSelected} 
                                  isRtl={isRtl} 
                                  onTriggerEvents={this.onTriggerEvents}
                                  eventAction={gaEventLabel.backMenu}
                                  eventLabel={menuPageSelected.discover}
                                  t={t}/>
                                  }
                              {(menuSelected === menuPageSelected.bottomResources) &&
                                <ExpandableMenu 
                                  content={resourcesContent} 
                                  rightIcon={isBottomMenuSelected && <div onClick={this.handleClose}><SvgIcon name="close" title={t('SvgTitle.close')}/></div>}
                                  backLinkContent={t("global.resources")}
                                  baseClassName={baseClassName} 
                                  menuSelected={menuSelected} 
                                  updateActiveMenuSelected={updateActiveMenuSelected}
                                  isRtl={isRtl} 
                                  t={t}/>
                                  }
                              {(menuSelected === menuPageSelected.readingProgram) &&
                                <ExpandableMenu 
                                  content={readingProgramMobileContent} 
                                  backLinkContent={<div><SvgIcon name={isRtl ? "chevron-right" : "chevron-left"} title={isRtl ? t('SvgTitle.chevron-right') : t('SvgTitle.chevron-left')} pushRight={!isRtl} pushLeft={isRtl}/>{t("global.back-to-resources")}</div>} 
                                  goBackTo={(isBottomMenuSelected === menuPageSelected.bottomResources) ? menuPageSelected.bottomResources : menuPageSelected.resources} 
                                  baseClassName={baseClassName} 
                                  menuSelected={menuSelected} 
                                  updateActiveMenuSelected={updateActiveMenuSelected}
                                  isRtl={isRtl} 
                                  t={t}/>
                                  }
                              {(menuSelected === menuPageSelected.bookLists) &&
                              <ExpandableMenu 
                                content={bookListsMobileContent} 
                                backLinkContent={<div><SvgIcon name={isRtl ? "chevron-right" : "chevron-left"} title={isRtl ? t('SvgTitle.chevron-right') : t('SvgTitle.chevron-left')} pushRight={!isRtl} pushLeft={isRtl}/>{t("global.back-to-resources")}</div>} 
                                goBackTo={(isBottomMenuSelected === menuPageSelected.bottomResources) ? menuPageSelected.bottomResources : menuPageSelected.resources} 
                                baseClassName={baseClassName} 
                                menuSelected={menuSelected} 
                                updateActiveMenuSelected={updateActiveMenuSelected}
                                isRtl={isRtl} 
                                t={t}/>
                                }
                              {(menuSelected === menuPageSelected.csf) &&
                                <ExpandableMenu 
                                  content={csfMobileContent} 
                                  backLinkContent={<div><SvgIcon name={isRtl ? "chevron-right" : "chevron-left"} title={isRtl ? t('SvgTitle.chevron-right') : t('SvgTitle.chevron-left')} pushRight={!isRtl} pushLeft={isRtl}/>{t("global.back-to-resources")}</div>} 
                                  goBackTo={(isBottomMenuSelected === menuPageSelected.bottomResources) ? menuPageSelected.bottomResources : menuPageSelected.resources} 
                                  baseClassName={baseClassName} 
                                  menuSelected={menuSelected} 
                                  updateActiveMenuSelected={updateActiveMenuSelected}
                                  isRtl={isRtl} 
                                  t={t}/>
                                }
                              {(menuSelected === menuPageSelected.flpHome) &&
                                <ExpandableMenu 
                                  content={flpHomeMobileContent} 
                                  backLinkContent={<div><SvgIcon name={isRtl ? "chevron-right" : "chevron-left"} title={isRtl ? t('SvgTitle.chevron-right') : t('SvgTitle.chevron-left')} pushRight={!isRtl} pushLeft={isRtl}/>{t("global.back-to-resources")}</div>} 
                                  goBackTo={(isBottomMenuSelected === menuPageSelected.bottomResources) ? menuPageSelected.bottomResources : menuPageSelected.resources} 
                                  baseClassName={baseClassName} 
                                  menuSelected={menuSelected} 
                                  updateActiveMenuSelected={updateActiveMenuSelected}
                                  isRtl={isRtl} 
                                  t={t}/>
                                }
                              {(menuSelected === menuPageSelected.ece) &&
                                <ExpandableMenu 
                                  content={eceMobileContent} 
                                  backLinkContent={<div><SvgIcon name={isRtl ? "chevron-right" : "chevron-left"} title={isRtl ? t('SvgTitle.chevron-right') : t('SvgTitle.chevron-left')} pushRight={!isRtl} pushLeft={isRtl}/>{t("global.back-to-resources")}</div>} 
                                  goBackTo={(isBottomMenuSelected === menuPageSelected.bottomResources) ? menuPageSelected.bottomResources : menuPageSelected.resources} 
                                  baseClassName={baseClassName} 
                                  menuSelected={menuSelected} 
                                  updateActiveMenuSelected={updateActiveMenuSelected}
                                  isRtl={isRtl} 
                                  t={t}/>
                                }
                              {(menuSelected === menuPageSelected.siteLang) && !window.location.pathname.includes('/getchildrenreading') &&
                                <ExpandableMenu 
                                  content={languageSelectionDropdownMobile} 
                                  backLinkContent={<div><SvgIcon name={isRtl ? "chevron-right" : "chevron-left"} title={isRtl ? t('SvgTitle.chevron-right') : t('SvgTitle.chevron-left')} pushRight={!isRtl} pushLeft={isRtl}/>{t("global.back-to-main")}</div>} 
                                  goBackTo={menuPageSelected.main} 
                                  baseClassName={baseClassName} 
                                  menuSelected={menuSelected} 
                                  updateActiveMenuSelected={updateActiveMenuSelected}
                                  isRtl={isRtl} 
                                  onTriggerEvents={this.onTriggerEvents}
                                  eventAction={gaEventLabel.backMenu}
                                  eventLabel={menuPageSelected.siteLang}
                                  t={t}/>
                              }
                              {(menuSelected === menuPageSelected.stem) &&
                                <ExpandableMenu 
                                  content={stemHomeMobileContent} 
                                  backLinkContent={<div><SvgIcon name={isRtl ? "chevron-right" : "chevron-left"} title={isRtl ? t('SvgTitle.chevron-right') : t('SvgTitle.chevron-left')} pushRight={!isRtl} pushLeft={isRtl}/>{t("global.back-to-resources")}</div>} 
                                  goBackTo={(isBottomMenuSelected === menuPageSelected.bottomResources) ? menuPageSelected.bottomResources : menuPageSelected.resources} 
                                  baseClassName={baseClassName} 
                                  menuSelected={menuSelected} 
                                  updateActiveMenuSelected={updateActiveMenuSelected}
                                  isRtl={isRtl} 
                                  t={t}/>
                                }
                                {(menuSelected === menuPageSelected.gcr) &&
                                <ExpandableMenu 
                                  content={gcrList} 
                                  backLinkContent={<div><SvgIcon name={isRtl ? "chevron-right" : "chevron-left"} title={isRtl ? t('SvgTitle.chevron-right') : t('SvgTitle.chevron-left')} pushRight={!isRtl} pushLeft={isRtl}/>{t("global.back-to-main")}</div>} 
                                  goBackTo={menuPageSelected.main} 
                                  baseClassName={baseClassName} 
                                  menuSelected={menuSelected} 
                                  updateActiveMenuSelected={updateActiveMenuSelected} 
                                  isRtl={isRtl} 
                                  onTriggerEvents={this.onTriggerEvents}
                                  eventAction={gaEventLabel.backMenu}
                                  eventLabel={menuPageSelected.gcr}
                                  t={t}/>
                                  }
                                {(menuSelected === menuPageSelected.bottomGcr) &&
                                  bottomGcrMob()
                                }
                              {(menuSelected === menuPageSelected.mobSiteLang) &&
                                <ExpandableMenu 
                                  content={languageSelectionDropdownMobile} 
                                  // backLinkContent={<div><SvgIcon name={isRtl ? "chevron-right" : "chevron-left"} title={isRtl ? t('SvgTitle.chevron-right') : t('SvgTitle.chevron-left')} pushRight={!isRtl} pushLeft={isRtl}/>{t("global.back-to-main")}</div>} 
                                  // goBackTo={menuPageSelected.main} 
                                  baseClassName={baseClassName} 
                                  menuSelected={menuSelected} 
                                  updateActiveMenuSelected={updateActiveMenuSelected}
                                  isRtl={isRtl} 
                                  onTriggerEvents={this.onTriggerEvents}
                                  eventAction={gaEventLabel.backMenu}
                                  eventLabel={menuPageSelected.siteLang}
                                  t={t}/>
                              }
                        </div>
                      }
                    </div>
                  )
                )
                :
                null
              }
        </div>
        
      </div>
    );
  }
}

SiteHeader.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    first_name: PropTypes.string
  }),
  viewport: PropTypes.object,
  logout: PropTypes.func.isRequired,
  offline: PropTypes.bool,
  openAuthModal: PropTypes.func,
  closeAuthModal: PropTypes.func,
  platformNotifications: PropTypes.array
};

export default SiteHeader;


// WEBPACK FOOTER //
// ./src/components/SiteHeader/SiteHeader.jsx